<template>
  <div class="ibox-title">
    <h5>{{title}} <small>{{info}}</small></h5>
  </div>
</template>
<script>
  export default {
    props: ['title', 'info']
  }
</script>




// WEBPACK FOOTER //
// IboxTitle.vue?1934cd84